import { AnalyticsNames } from '../models/analytics-names';
import { Engagement } from '../models/engagement';
import { Entity } from '../models/entity';
import { sendEvent } from '../store/analytics';
import { read } from '../store/good-cop';

export async function passPositiveEngagement(params: {
  entity: Entity;
  id: string;
  engagement: Engagement;
}): Promise<void> {
  const startParams = await read();
  const totalParams = {
    ...startParams,
    ...params,
  };
  sendEvent(AnalyticsNames.PositiveEngagementPassed, totalParams);
}
